// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9494554e","744":"3caf4efd","801":"3c56356f"}[chunkId] + ".chunk.js";
};